// CyberRain — ambient digital-rain columns behind the chat, only under the Cyberpunk theme.
// Pure decoration (pointer-events:none); re-renders on theme change via useTheme.
import { useTheme } from "../hooks/useTheme.js";

export default function CyberRain() {
  const { theme } = useTheme();
  if (theme !== "cyberpunk") return null;
  return (
    <div className="cy-rain" aria-hidden>
      {Array.from({ length: 22 }).map((_, i) => (
        <span
          key={i}
          style={{
            left: `${(i * 4.7 + 2) % 100}%`,
            height: `${40 + ((i * 37) % 120)}px`,
            animationDuration: `${4 + (i % 6)}s`,
            animationDelay: `${-(i % 8)}s`,
          }}
        />
      ))}
    </div>
  );
}
